import { isValidPhoneNumber } from 'libphonenumber-js';
import { validateEmail } from 'src/utils/common';
import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string()
    .required('SCHEMA_ERRORS.NAME_REQUIRED')
    .max(30, 'SCHEMA_ERRORS.NAME_MAX_LENGTH'),
  department: Yup.string().required('SCHEMA_ERRORS.SELECT_VALUE'),
  position: Yup.string().required('SCHEMA_ERRORS.SELECT_VALUE'),
  phone: Yup.string()
    .test('phone', 'SCHEMA_ERRORS.PHONE_INVALID', value => {
      const phoneNumber = isValidPhoneNumber(`+${value}`);
      return phoneNumber;
    })
    .required('SCHEMA_ERRORS.PHONE_REQUIRED'),
  email: Yup.string()
    .test('email', 'SCHEMA_ERRORS.EMAIL_FORMAT_INVALID', validateEmail)
    .required('SCHEMA_ERRORS.EMAIL_REQUIRED')
});
